const { useState } = require('react');

export function useFormValues<T>(
  initialValues: T
): {
  formValues: T;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  errors: T;
  setErrors: React.Dispatch<React.SetStateAction<any>>;
  setFormValues: React.Dispatch<React.SetStateAction<T>>;
} {
  const [formValues, setFormValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialValues);

  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    setErrors(initialValues);
    setFormValues((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  return { formValues, handleChange, errors, setErrors, setFormValues };
}
